import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../shared/source/context/context';
import { skillShortSchema } from '../../../../shared/source/data-contract/skill';

import type { SkillShort } from '../../../../shared/source/data-contract/skill';
import type { Pathname } from '../../../../shared/source/http-fetcher/http-fetcher';
import type { QueryKey, UseQueryResult } from '@tanstack/react-query';
import type Maybe from 'true-myth/maybe';

export type UseTalentDirectorySkillSearchResult = UseQueryResult<readonly SkillShort[]>;

export const useTalentDirectorySkillSearch = (options: {
    readonly enabled: boolean;
    readonly searchTerm: Maybe<string>;
}): UseTalentDirectorySkillSearchResult => {
    const { enabled, searchTerm } = options;
    const { applicationState, validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname: Pathname = `/global/directory/skills/search`;
    const queryKey: QueryKey = [pathname, 'get', applicationState.language.code, searchTerm];

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(skillShortSchema.array(), {
                pathname,
                requestOptions: {
                    searchParams: {
                        limit: 20,
                        searchTerm: searchTerm.unwrapOr(''),
                    },
                },
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey,
    });
};
